import { SVGFC } from '@repo/toolkit/types'

const InformationIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4097_108896)">
        <path
          d="M12 3C7.02571 3 3 7.02525 3 12C3 16.9742 7.02525 21 12 21C16.9743 21 21 16.9747 21 12C21 7.02578 16.9747 3 12 3ZM12 19.7442C7.72985 19.7442 4.25582 16.2702 4.25582 12C4.25582 7.72982 7.72985 4.25582 12 4.25582C16.2701 4.25582 19.7442 7.72982 19.7442 12C19.7442 16.2702 16.2701 19.7442 12 19.7442Z"
          fill={color}
        />
        <path
          d="M12.0001 10.502C11.467 10.502 11.0879 10.7271 11.0879 11.0588V15.5724C11.0879 15.8567 11.467 16.141 12.0001 16.141C12.5095 16.141 12.9241 15.8567 12.9241 15.5724V11.0587C12.9241 10.7271 12.5095 10.502 12.0001 10.502Z"
          fill={color}
        />
        <path
          d="M12.0002 7.71875C11.4553 7.71875 11.0288 8.10969 11.0288 8.55986C11.0288 9.01007 11.4553 9.41286 12.0002 9.41286C12.5333 9.41286 12.9598 9.01007 12.9598 8.55986C12.9598 8.10969 12.5333 7.71875 12.0002 7.71875Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_4097_108896">
          <rect width="18" height="18" fill={color} transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default InformationIcon
